import type React from "react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { check_in_with_claim } from "../../apis/helper";
import { parseJwt } from "../../utils";

type Status = "checking" | "success" | "error";

export const CheckInPage: React.FC = () => {
	const [searchParams] = useSearchParams();
	const token = searchParams.get("token");
	const jwtPayload = token ? parseJwt(token) : null;
	const eventId = jwtPayload?.sub;

	const [status, setStatus] = useState<Status>("checking");

	useEffect(() => {
		if (!eventId || !token) {
			setStatus("error");
			return;
		}

		check_in_with_claim(eventId, token)
			.then(() => setStatus("success"))
			.catch(() => setStatus("error"));
	}, [eventId, token]);

	return (
		<div className="flex items-center justify-center min-h-screen bg-white">
			<div className="flex flex-col items-center gap-4 text-center px-6">
				{status === "checking" && (
					<p className="text-[18px] text-[#404040]">Checking in...</p>
				)}
				{status === "success" && (
					<>
						<div className="w-16 h-16 rounded-full bg-[#e9f9ee] flex items-center justify-center">
							<span className="text-[32px]">&#10003;</span>
						</div>
						<p className="text-[20px] font-medium text-[#1eb44a]">
							Checked in!
						</p>
						<p className="text-[16px] text-[#6d6d6d]">
							You can close this window now.
						</p>
					</>
				)}
				{status === "error" && (
					<>
						<p className="text-[20px] font-medium text-[#e90035]">
							Check-in failed
						</p>
						<p className="text-[16px] text-[#6d6d6d]">
							The link may have expired. Please scan the QR code again.
						</p>
					</>
				)}
			</div>
		</div>
	);
};
